import { useEffect, useState } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { useIsPillBorderRadius } from 'portals-platform-lib';
import { PAGE_CONTENT_SPACING } from '../constants/layout';
import { usageTracker } from '../utils/usageTracker';
import { InboxNavPanel } from '../components/InboxNavPanel';
import { TicketThreadViewerWrapper } from '../components/TicketThreadViewerWrapper';
import { useIsMobile } from '../hooks/useBreakpoint';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function TicketDetails() {
  const isMobile = useIsMobile();
  const isUsingPillBorderRadius = useIsPillBorderRadius();
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [selectedDetailsPanelTab, setSelectedDetailsPanelTab] = useState('details');
  useEffect(() => {
    usageTracker.track('Customer Portal App', 'Page Viewed', {
      screen: 'ticket-details'
    });
  }, []);
  const outerFlexProps = isMobile ? {} : {
    borderWidth: '100',
    borderStyle: 'solid',
    borderColor: 'border-core-subtle',
    borderRadius: isUsingPillBorderRadius ? '0' : '300',
    overflow: 'hidden',
    marginBlockEnd: PAGE_CONTENT_SPACING,
    marginInlineStart: PAGE_CONTENT_SPACING,
    marginInlineEnd: PAGE_CONTENT_SPACING
  };
  return /*#__PURE__*/_jsxs(Flex, Object.assign({
    flexGrow: "1"
  }, outerFlexProps, {
    children: [!isMobile && /*#__PURE__*/_jsx(InboxNavPanel, {}), /*#__PURE__*/_jsx(TicketThreadViewerWrapper, {
      isPanelOpen: isPanelOpen,
      setIsPanelOpen: setIsPanelOpen,
      selectedDetailsPanelTab: selectedDetailsPanelTab,
      setSelectedDetailsPanelTab: setSelectedDetailsPanelTab
    })]
  }));
}